import { observable, action, decorate } from 'mobx';
import Ajax from '../ajax/ajax';
import { allRbacPermissionGroups, rbacPermissionGroups, reportingPermissionGroups, roleLifecyclePermissionGroups } from '../helper/constants';
import { eventBusMessages, eventTypesForBus } from '../helper/enums';
import EventBus from '../helper/event.bus';

export class UserStore {

    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    currentUser = undefined;

    currentUserID;

    setCurrentUser = (user) => this.currentUser = user;

    // setCurrentUserID = (id) => this.currentUserID = id;

    getCurrentUserInfo = () => Ajax.getLoggedInUser(this.getCurrentUserInfoSuccess, this.getCurrentUserInfoError);

    getCurrentUserInfoSuccess = (response) => {
        if (response.data.email === null) {
            window.location.pathname = "/login";
        } else {
            this.setCurrentUser(response.data);
            this.currentUserID = this.currentUser.id;
        }
    }

    getCurrentUserInfoError = (error) => console.log("Userstore getCurrentUserInfoError: Response from request" + error);

    logout = (data) => Ajax.logout(null, this.logoutSuccess, this.logoutError);

    logoutSuccess = () => {
        this.setCurrentUser(undefined);
        window.location.pathname = "/login";
        EventBus.publish(eventTypesForBus.logout, eventBusMessages.logout);
    }
    logoutError = (response) => {
        console.log(response);
    }

    get isUserPresent() {
        return this.currentUser !== undefined;
    }

    get isUserCiso() {
        return this.currentUser.memberOf.find(x => x.includes(rbacPermissionGroups.mpCiso)) !== undefined;
    }

    get isReportingUser() {
        return this.currentUser.memberOf.find(x => x.includes(rbacPermissionGroups.mpReports)) !== undefined;
    }

    get isRoleLifecycleUser() {
        return this.currentUser.memberOf.find(x => x.includes(rbacPermissionGroups.mpUsers)) !== undefined;
    }

    get isUserAdmin() {
        return this.currentUser.memberOf.find(x => x.includes(rbacPermissionGroups.mpAdmin)) !== undefined;
    }

    get isUserLicenseAdmin(){
        return this.currentUser.memberOf.find(x => x.includes(rbacPermissionGroups.mpLicenseAdmin)) !== undefined;
    }

    get isUserLicenseManager(){
        return this.currentUser.memberOf.find(x => x.includes(rbacPermissionGroups.mpLicenseManager)) !== undefined;
    }

    get isUserManager() {
        return this.currentUser.memberOf.find(x => x.includes(rbacPermissionGroups.mpManager)) !== undefined;
    }

    get isUserSoxCompliance() {
        return this.currentUser.memberOf.find(x => x.includes(rbacPermissionGroups.mpCompliance)) !== undefined;
    }

    get isUserNotEligibleForRbac() {
        return !allRbacPermissionGroups.some(pg => this.currentUser.memberOf.find(x => x.includes(pg)));
    }

    get shouldRenderRoleLifecycleHeaderItem() {
        return roleLifecyclePermissionGroups.some(pg => this.currentUser.memberOf.find(x => x.includes(pg)));
    }

    get shouldRenderReportinHeaderItem() {
        return reportingPermissionGroups.some(pg => this.currentUser.memberOf.find(x => x.includes(pg)));
    }

}
decorate(UserStore, {
    currentUser: observable,
    currentUserID: observable,
    setCurrentUser: action,
    setCurrentUserID: action
})